<template>
  <v-stepper :value="value" flat class="rmr-stepper" @change="$emit('input', $event)">
    <v-stepper-header class="rmr-stepper__header">
      <template v-for="(step, index) in steps">
        <v-stepper-step
          :key="step"
          :step="index + 1"
          :complete="value > index + 1"
        >{{ step }}</v-stepper-step>
        <v-divider
          v-if="index < steps.length - 1"
          :key="'div-' + index"
          class="rmr-stepper__divider"
          :class="{
            'rmr-stepper__divider--complete': value > index + 2,
            'rmr-stepper__divider--progress': value === index + 2,
          }"
        />
      </template>
    </v-stepper-header>

    <v-stepper-items>
      <slot></slot>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
export default {
  name: "RmrStepper",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: {
      type: Number,
      required: true,
    },
    steps: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/variables";

.rmr-stepper {
  box-shadow: none !important;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}

.rmr-stepper__header {
  box-shadow: none !important;
  padding: 12px 24px 8px;
  position: sticky;
  top: 0;
  z-index: 3;
  background: linear-gradient(180deg, $rmr-surface-0 0%, $rmr-surface-2 100%);
  border-bottom: 1px solid $rmr-border-hover;
}

.rmr-stepper__divider {
  margin: 0 8px !important;
  border: none !important;
  height: 2px !important;
  max-height: 2px !important;
  border-radius: 2px;
  background: $rmr-border-hover !important;
  align-self: center;
}

.rmr-stepper__divider--complete {
  background: $rmr-green !important;
}

.rmr-stepper__divider--progress {
  background: linear-gradient(to right, $rmr-green, $rmr-indigo) !important;
}

.rmr-stepper__header .v-stepper__step {
  padding: 12px 8px !important;
}

.rmr-stepper__header .v-stepper__label {
  font-size: $rmr-fs-body !important;
  font-weight: 700 !important;
  color: $rmr-text-muted !important;
}

.rmr-stepper__header .v-stepper__step__step {
  width: 34px;
  height: 34px;
  font-size: $rmr-fs-title;
  font-weight: 800;
  box-shadow: 0 6px 14px rgba(15, 23, 42, 0.08);
}

.rmr-stepper__header .v-stepper__step--active .v-stepper__step__step {
  background: linear-gradient(135deg, $rmr-indigo-accent 0%, $rmr-indigo 100%) !important;
}

.rmr-stepper__header .v-stepper__step--active .v-stepper__label {
  color: $rmr-indigo-dark !important;
}

.rmr-stepper__header .v-stepper__step--complete .v-stepper__step__step {
  background: $rmr-green !important;
}

.rmr-stepper .v-stepper__items {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-gutter: stable;
  @include rmr-scrollbar;
}

@media (max-width: 960px) {
  .rmr-stepper__header {
    padding-left: 16px;
    padding-right: 16px;
  }
}
</style>
